import './ui/polarize.css';
import './ui/menu';
import { buildCity } from './game/city';
import { proceduralCity } from './world/load';
import { CITIES, BB } from './game/state';
import { rig } from './game/scene';
import { frame } from './game/loop';

// idle backdrop behind the menu
buildCity(proceduralCity(), CITIES.brickell).then(()=>{ rig.base.set(0, rig.h, BB.half+60); });
requestAnimationFrame(frame);

// debug/test handle — the same state the backtick panel shows
import { S } from './game/state';
import { endRun } from './game/modes';
import { T } from './world/tiles';
import { buildings } from './game/entities';
import { sampleGround, photoAvailable } from './world/tiles';
import { bloom, sky, sun, renderer, composer, grade, gtao, smaa, scene } from './game/scene';
import { MP } from './game/multiplayer';
import { probeTarget } from './game/loop';
(window as any).__polarize = { S, endRun, T, buildings, sampleGround, photoAvailable, MP, rig, probeTarget, bloom, sky, sun, renderer, composer, grade, gtao, smaa, scene };
